declare global {
	class FoxentryBase {
		constructor(key: string);
		public deactivate(): void;
		public activate(): void;
		public isFormValid(form: HTMLFormElement): boolean;
		public validationInProgress(): boolean;
	}

	interface Window {
		Foxentry?: FoxentryBase;
	}
}

export function initFoxentry(key: string): void {
	window.Foxentry = undefined;
	const script = document.createElement("script");

	script.async = true;
	script.src = "https://cdn.foxentry.cz/lib";
	document.head.appendChild(script);

	script.onload = (): void => {
		window.Foxentry = new FoxentryBase(key);
	};
}
